module.exports = __webpack_public_path__ + "static/media/fly0148.87210ea7.webp";